import { Navigate } from "react-router-dom";
import { useContext } from "react";
import { Context } from "../../context/UserContext";

export default function ProtectedRoute({ children }) {

  const { authenticated } = useContext(Context);

  if (!authenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
}